// extracted by mini-css-extract-plugin
export default {"layout":"BingoGames_layout__xrfAq","link":"BingoGames_link__TFbwh"};